<template>
  <b-container fluid class="contact">
    <b-row>
      <b-col md="4" sm="12">
        <Navbar class="d-none d-md-flex"></Navbar>
      </b-col>
      <b-col md="8" sm="12">
        <div class="contact-text">
          <p>
            Je vous intéresse ? C'est bon signe !
          </p>
          <div>
            <span>• </span><a href="tel:+33616941856">06 16 94 18 56</a>
          </div>
          <div>
            <span>• </span><a href="mailto:bonjour@arthurbeauboisjude.com">
            bonjour@arthurbeauboisjude.com</a>
          </div>
          <p>
            ... et vous pouvez aussi me suivre sur Twitter !
          </p>
          <Tweet :id="tweetId"
                 widget-class="tweeter-container"></Tweet>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { Tweet } from 'vue-tweet-embed';
import Navbar from '@/components/Navbar.vue';
import Constants from '@/constants';

export default {
  components: {
    Navbar,
    Tweet,
  },
  data() {
    return {
      tweetId: Constants.tweetId,
    };
  },
};
</script>

<style lang="scss" scoped>
  span, a {
    font-size: $font-size-large;
    white-space: nowrap;
    @media (max-width: 576px) {
      font-size: $font-size-medium;
    }
    color: $color-black;
    margin-bottom: 24px;
    font-family: "Robotoo";
    font-weight: bold;
  }
  p {
    margin-top: 24px;
    margin-bottom: 24px;
    font-family: "Robotoo";
    @media (max-width: 576px) {
      font-size: $font-size-medium;
    }
  }
  .contact-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .tweeter-container {
    width: 100%;
  }
</style>
